import { render, staticRenderFns } from "./downloads.vue?vue&type=template&id=566bf31d"
import script from "./downloads.vue?vue&type=script&lang=js"
export * from "./downloads.vue?vue&type=script&lang=js"
import style0 from "./downloads.vue?vue&type=style&index=0&id=566bf31d&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\project\\fashang\\cqykdx\\student_pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('566bf31d')) {
      api.createRecord('566bf31d', component.options)
    } else {
      api.reload('566bf31d', component.options)
    }
    module.hot.accept("./downloads.vue?vue&type=template&id=566bf31d", function () {
      api.rerender('566bf31d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/downloads/downloads.vue"
export default component.exports